<app-loader [isBusy]="isBusy">
    <ng-template>
        <form [formGroup]="form">
            <div class="modal-header">
                <h4 class="modal-title">{{ title }} - {{ entity | translate }} - {{ id }}</h4>
                <button class="close" type="button" aria-label="Close" (click)="activeModal.close(null)">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <ng-container formArrayName="holdTypes">
                    @for (item of form.get('holdTypes').controls; track item; let i = $index) {
                        <kendo-expansionpanel
                            [expanded]="holdTypes[i].expanded"
                            [ngClass]="{ 'inactive-panel': !holdTypes[i].active }"
                            (action)="onAction(i)">
                            <ng-template kendoExpansionPanelTitleDirective>
                                <div>
                                    <span class="font-weight-bold">
                                        {{ holdTypes[i].cargoHoldType.localizedCode }}
                                        {{
                                            holdTypes[i].cargoHoldType.name
                                                ? ' - ' + holdTypes[i].cargoHoldType.name
                                                : ''
                                        }}
                                        {{ !holdTypes[i].active ? ('(inactive)' | translate) : '' }}
                                    </span>
                                </div>
                            </ng-template>
                            <div [formGroup]="item">
                                <div class="row">
                                    <div class="col-6">
                                        <form-datetime
                                            formControlName="createdDate"
                                            labelText="{{ 'Hold Activated' | translate }}"></form-datetime>
                                    </div>
                                    <div class="col-6">
                                        <form-datetime
                                            formControlName="unholdedDate"
                                            labelText="{{ 'Hold Lifted' | translate }}"></form-datetime>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <form-textbox
                                            formControlName="remarkHold"
                                            labelText="{{ 'Hold Remark' | translate }}"></form-textbox>
                                    </div>
                                </div>
                                @if (!holdTypes[i].active) {
                                    <div class="row">
                                        <div class="col">
                                            <form-textbox
                                                formControlName="remarkUnhold"
                                                labelText="{{ 'Unhold Remark' | translate }}"></form-textbox>
                                        </div>
                                    </div>
                                }
                                <div class="row">
                                    <div [ngClass]="holdTypes[i].cargoHoldType.id === 'HXRAY' ? 'col-8' : 'col-12'">
                                        <form-textbox
                                            formControlName="additionalInfo"
                                            labelText="{{ 'Additional Information' | translate }}"></form-textbox>
                                    </div>
                                    @if (holdTypes[i].cargoHoldType.id === 'HXRAY') {
                                        <div class="col-4">
                                            <form-checkbox
                                                formControlName="xRay"
                                                labelText="{{ 'X-Ray Completed' | translate }}"></form-checkbox>
                                        </div>
                                    }
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <kendo-label
                                            text="{{ 'Attachments' | translate }}"
                                            [for]="attachments"></kendo-label>
                                        <kendo-fileselect
                                            #attachments
                                            formControlName="attachments"
                                            [restrictions]="attachmentFileUploadRestrictions"
                                            [multiple]="true"
                                            (select)="fileSelected($event, holdTypes[i].id)"
                                            (remove)="removeFile($event, holdTypes[i].id)">
                                            <ng-template kendoFileSelectFileInfoTemplate let-files>
                                                <span
                                                    (click)="
                                                        fileDownloadService.downloadAttachment(files[0].attachedFile)
                                                    ">
                                                    {{ files[0].name }}
                                                </span>
                                            </ng-template>
                                            <kendo-upload-messages
                                                select="{{ 'Select files' | translate }}"
                                                dropFilesHere="{{
                                                    'Drop files here to select' | translate
                                                }}"></kendo-upload-messages>
                                        </kendo-fileselect>
                                    </div>
                                </div>
                            </div>
                        </kendo-expansionpanel>
                    }
                </ng-container>
            </div>

            <div class="modal-footer">
                <button
                    class="btn btn-sm btn-primary mr-2"
                    type="button"
                    [disabled]="!isFormChanged()"
                    (click)="saveDetails()">
                    <fa-icon [icon]="['fas', 'check']"></fa-icon>
                    &nbsp;&nbsp;{{ 'Save' | translate }}
                </button>
                <button class="btn btn-sm btn-secondary" type="button" (click)="activeModal.close(null)">
                    <fa-icon [icon]="['fas', 'times']"></fa-icon>
                    &nbsp;&nbsp;{{ 'Cancel' | translate }}
                </button>
            </div>
        </form>
    </ng-template>
</app-loader>
